import { doDebugLog } from '@marriott/mi-apollo-client-utils';
import { monthsArray } from '../../constants/lib/constants';
import { resType } from './index.types';

export function isDateAfterToday(dateString: string): boolean {
  const year = +dateString.substring(0, 4);
  const month = +dateString.substring(5, 7);
  const day = +dateString.substring(8, 10);
  const date = new Date(year, month - 1, day);
  return new Date(date.toDateString()) > new Date(new Date().toDateString());
}

// TODO: Please add code comment explaining what this function does.
export const formatPhoneNumber = (phoneNumberString: string): string => {
  doDebugLog(
    `[PerfTesting][SMHotelGalleryTitle] Entering the formatPhoneNumber function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`,
    'info'
  );
  let returnedNumber = '';
  if (phoneNumberString?.includes('+')) {
    if (phoneNumberString.replaceAll(' ', '').replaceAll('-', '')?.split('')?.length > 12) {
      returnedNumber = phoneNumberString
        .replaceAll(' ', '')
        .replaceAll('-', '')
        .replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3');
    } else {
      returnedNumber = phoneNumberString
        .replaceAll(' ', '')
        .replaceAll('-', '')
        .replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2-$3-$4');
    }
  }
  doDebugLog(
    `[PerfTesting][SMHotelGalleryTitle] Exiting the formatPhoneNumber function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`,
    'info'
  );
  return returnedNumber;
};

// TODO: Please add code comment explaining what this function does.
export const getCommaSeparator = (numb: number | string): string => {
  doDebugLog(
    `[PerfTesting][SMHotelGalleryTitle] Entering the getCommaSeparator function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`,
    'info'
  );
  const str = numb.toString().split('.');
  str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  doDebugLog(
    `[PerfTesting][SMHotelGalleryTitle] Exiting the getCommaSeparator function at time: ${new Date().getHours()} ${new Date().getMinutes()} ${new Date().getSeconds()} ${new Date().getMilliseconds()}`,
    'info'
  );
  return str.join('.');
};

// TODO: Please add code comment explaining what this function does.
export function dateReturner(dateString: string): string {
  const monthIndex = (+dateString.substring(5, 7) - 1).toString();
  const year = +dateString.substring(0, 4);
  const monthMapping: resType['res'] = monthsArray;
  return `${monthMapping[monthIndex]['monthLabel']} ${year}`;
}

export const updateDatalayerObjForRFP = (dataLayer?: Record<string, unknown>, propertyMarshaCode?: string) => {
  dataLayer && (dataLayer['prop_marsha_code'] = propertyMarshaCode);
};

const canUseDOM = !!(typeof window !== 'undefined' && window.document);

/**
 * Function to check if page is RTL or not
 * @returns {boolean} Returns true if RTL, false if not
 */
const isRTLEnabledCheck = (): boolean => {
  const htmlEle = canUseDOM && (document.querySelector('html') as HTMLElement);
  if (htmlEle && htmlEle?.getAttribute('dir') === 'rtl') {
    return true;
  }
  return false;
};
export const isRTLEnabled = isRTLEnabledCheck();
